module.exports = __webpack_public_path__ + "assets/img/structure-d6704109.png";